import React, { useState, useRef, useEffect } from "react";
import { createBrowserHistory } from "history";
import { Route, Router } from "react-router-dom";
import Loading from "../shared/loading/Loading";
import NSCApp from "./NSCApp";
import AccessDeniedAsBevDisabled from "../components/accessDenied/AccessDeniedAsBevDisabled";
import DealerApp from "./DealerApp";
import FieldViewApp from "./FieldViewApp";
import { SA_URL } from "../utils/EmpUtil";
import { I18nextProvider } from "react-i18next";
import i18n from "../common/i18n";
import { initDynatrace } from "../shared/services/dynatrace/DynatraceService";

let loadingCount = 0;

export const hideOrShow = (show, setZIndex = false) => {
  if (show) {
    loadingCount += 1;
    if (document.getElementById("loading")) {
      document.getElementById("loading").style.display = "block";
    }
    if (document.getElementById("appWrapper") && setZIndex) {
      document.getElementById("appWrapper").style.zIndex = "-1";
    }
  } else {
    if (loadingCount === 1) {
      if (document.getElementById("loading")) {
        document.getElementById("loading").style.display = "none";
      }
      if (
        document.getElementById("appWrapper") &&
        (document.getElementById("appWrapper").style.zIndex === "-1" ||
          document.getElementById("appWrapper").style.zIndex === -1)
      ) {
        document.getElementById("appWrapper").style.zIndex = "auto";
      }
    }
    if (loadingCount > 0) {
      loadingCount -= 1;
    }
  }
};

const App = ({
  token: initialToken = null,
  userDetails: initialUserDetails = null,
}) => {
  // MsalAuthWrapper is the only entry point that mounts this component
  // and it always provides both props. Refuse to render in the absence
  // of either — the wrapper will be showing the Loading/error UI.
  const [renderApp] = useState(!!(initialToken && initialUserDetails));

  // i18next-xhr-backend uses raw XHR, so the axios interceptor doesn't
  // attach the bearer token for translation requests. We pass the token
  // explicitly to i18n init; that's the only thing initialToken is used
  // for now.
  const i18nRef = useRef(null);
  if (!i18nRef.current) {
    i18nRef.current = i18n(initialToken);
  }
  const userDetailsRef = useRef(initialUserDetails);

  useEffect(() => {
    initDynatrace();
  }, []);

  if (!initialToken || !initialUserDetails) {
    return <Loading />;
  }

  const currentUrl = window.location.href;
  if (currentUrl && currentUrl.includes("/sa")) {
    window.location.href = SA_URL;
  }

  const isNsc = (userDetails) => userDetails.userType === "nsc";

  const isDealer = (userDetails) => userDetails.userType === "dealer";

  const isFieldView = (userDetails) => userDetails.userType === "field_view";

  return renderApp ? (
    <I18nextProvider i18n={i18nRef.current}>
      <Router history={createBrowserHistory()}>
        <Loading brand={userDetailsRef.current.brand} />
        <Route
          render={(props) => {
            if (isDealer(userDetailsRef.current)) {
              return (
                <DealerApp
                  {...props}
                  isNsc={false}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  hideOrShow={hideOrShow}
                />
              );
            } else if (isNsc(userDetailsRef.current)) {
              return (
                <NSCApp
                  {...props}
                  isNsc={true}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  hideOrShow={hideOrShow}
                />
              );
            } else if (isFieldView(userDetailsRef.current)) {
              return (
                <FieldViewApp
                  {...props}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  hideOrShow={hideOrShow}
                />
              );
            } else {
              if (document.getElementById("loading")) {
                return <AccessDeniedAsBevDisabled {...props} />;
              } else {
                return null;
              }
            }
          }}
        />
      </Router>
    </I18nextProvider>
  ) : (
    <Loading />
  );
};

export default App;
